import styled from '@emotion/styled'

const StyledMenuHorizontal = styled.div`
  display: flex;
  align-items: center;
  min-height: 58px;
  height: 58px;
  padding: 0 14px 0 14px;
  border-bottom: 1px solid #ebeef2;
  background: ${(props) => {
    const { backgroundColor } = props
    return backgroundColor
  }};
`

// 导航内容部分
const StyledMenuContent = styled.div`
  display: flex;
  align-items: center;
  padding: 0 24px;
  height: 100%;
  p {
    margin: 0;
  }
`

// 单个Nav Item
const StyledMenuContentNavItem = styled.div`
  position: relative;
  height: 100%;
  .menu-first-level {
    height: 100%;
    padding: 0 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 0 0 8px 8px;
    .menu-first-level-name {
      text-align: center;
      font-family: Roboto, sans-serif;
      margin-right: 8px;
      font-size: ${({ theme }) => theme.fontSizes.md};
      color: ${(props) => {
        const { textColor } = props
        return textColor
      }};
      &:hover {
        color: ${(props) => {
          const { hoverFontColor } = props
          return hoverFontColor
        }};
      }
    }
  }
  .menu-horizontal-nav-item-active {
    background: rgb(var(--ow-primary-color));
    .menu-first-level-name {
      font-weight: bold;
    }
  }
  .menu-children-level {
    position: absolute;
    z-index: 100;
    top: 100%;
    left: 0;
    white-space: nowrap;
    background: #fff;
    padding: 8px 0;
    border: 1px solid #e5e9f2;
    box-shadow: 0 0.125rem 0.25rem rgb(43 55 72 / 15%);
    border-radius: 4px;
    transition: opacity 0.4s, margin 0.2s;
    .menu-child-level-name {
      cursor: pointer;
      padding: 8px 20px;
      font-size: 13px;
      color: ${(props) => {
        const { textColor } = props
        return textColor
      }};
      &:hover {
        color: ${(props) => {
          const { hoverFontColor } = props
          return hoverFontColor
        }};
        background: #f5f6fa;
      }
    }
    .menu-horizontal-nav-child-item-active {
      color: ${({ hoverFontColor }) =>
        hoverFontColor || 'rgb(var(--ow-primary-color))'};
      background: #f5f6fa;
    }
  }
`

export { StyledMenuHorizontal, StyledMenuContent, StyledMenuContentNavItem }
